<template>
  <div>
    <div class="color-choice col-hspace">
      <button
        type="button"
        class="color-choice__item"
        v-for="(color, index) in colors"
        :class="{'active': isActive(color.name)}"
        :key="index"
        @click="changeColor(color)"
      >
        <span :class="color.name"></span>
        <p class="color-choice__title">{{ color.title }}</p>
      </button>
    </div>

    <div class="col-xs-12 col-big-vtspace" v-show="!!active.length">
      <p class="tcenter">
        <span class="bold" v-if="active.length === 1">Couleur sélectionnée :</span>
        <span class="bold" v-else>Couleurs sélectionnées :</span>

        <span v-for="(color, i) in active" :key="i">
          &nbsp;{{ color.title }}<span v-if="(i !== 0 && active.length === 1) || i !== active.length - 1">,</span>
        </span>
      </p>
    </div>
  </div>

</template>

<script>
export default {
  props: {
    colors: {
      type: Array,
      default: () => [],
    },
    active: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      isDesktop: false,
    };
  },

  mounted() {
    this.mobile();
  },

  methods: {
    mobile() {
      this.isDesktop = window.matchMedia('(max-width: 768px)').matches;
    },

    changeColor(color) {
      this.$emit('change-color', color);
    },

    hovered(value, index) {
      this.$emit('hover-color', value, index);
    },

    isActive(colorName) {
      return !!this.active.filter(color => color.name === colorName).length;
    },
  },
};
</script>
